import styled from 'styled-components';

export const Form = styled.form.attrs(({ method = 'post', autoComplete = 'off' }) => ({
  method,
  autoComplete,
}))`
  display: flex;
  flex-direction: ${({ flexDirection = 'column' }) => flexDirection};
  align-items: ${({ alignItems = 'center' }) => alignItems};
  justify-content: ${({ justifyContent = 'initial' }) => justifyContent};
  width: ${({ width = '100%' }) => width};
  height: ${({ height = 'auto' }) => height};
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`}
  ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth};`}
`;
